import { Dragable } from '../dragable/index.js'
import { UiModal } from './modal.js'

const template = `<ui-modal id="ui-modal"></ui-modal>`

type ResizableEdges = Readonly<{
    top?: boolean,
    left? : boolean,
    bottom?: boolean,
    right?: boolean,
}>

export class UiFloatModal {
    modalComponent: UiModal
    root: HTMLDivElement
    uiModal: Dragable;

    constructor(content: string | HTMLElement, resizable = false, edges: ResizableEdges | null = null, minSize = { width: 250, height: 50 }, zIndex = 10002000) {
        this.root = document.createElement('div')
        this.root.nodeType
        this.root.innerHTML = template
        this.modalComponent = this.root.querySelector('ui-modal')!;
        if (typeof content !== "string") this.modalComponent.appendChild(content)
        else this.modalComponent.innerHTML = content
        // @ts-expect-error
        this.uiModal = new Dragable(this.root, this.modalComponent.modalHeader, resizable, edges, minSize, zIndex)
        this.modalComponent.uiModal = this.uiModal
        // @ts-ignore
        this.modalComponent.root = this.root
        // @ts-ignore
        this.modalComponent.rootDestroy = this.destroy.bind(this);
    }
    destroy(){
        if (this.uiModal) {
            this.uiModal.destroy();
            // @ts-expect-error
            this.uiModal = null;
        }
        if (this.modalComponent && this.modalComponent.parentElement) {
            this.modalComponent.parentElement.removeChild(this.modalComponent);
            // @ts-expect-error
            this.modalComponent = null;
        }

        // @ts-expect-error
        this.root = null;
    }

    setPosition(coords: {x: number, y: number}): void {
        if (this.uiModal !== null) {
            this.uiModal.initialPosition = [coords.x, coords.y];
        }
    }

    open() {}

    close() {}
}